/**
 * Dear John parent grouping (SEO theme)
 * Every colorway in a group stays its own collection card (collection order).
 * Each card shows the full group swatches with that colorway as the main/active.
 * Preferred key: custom.style_group
 * Fallbacks: custom.product_groups → style title
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'djProductGroups';
  var PAGE_SIZE = 50;

  function config() {
    return window.djParentGroupConfig || {};
  }

  function showSoldOut() {
    var cfg = config();
    return cfg.showSoldOut !== false;
  }

  function splitPipe(value) {
    return String(value || '')
      .split('||')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function productContext(type, title, tags) {
    return [type || '', title || '', Array.isArray(tags) ? tags.join(' ') : '']
      .join(' ')
      .toLowerCase();
  }

  function isOverallProduct(type, title, tags) {
    return /overall|jumpsuit|romper/.test(productContext(type, title, tags));
  }

  function isTopsProduct(type, title, tags) {
    if (isOverallProduct(type, title, tags)) return false;
    return /top|tee|shirt|blouse|sweater|knit|jacket|dress|tank|cardigan|vest|bodysuit|hoodie|pullover/.test(
      productContext(type, title, tags)
    );
  }

  function isBottomsProduct(type, title, tags) {
    if (isOverallProduct(type, title, tags) || isTopsProduct(type, title, tags)) return false;
    return /jean|pant|skirt|short|legging|bottom/.test(productContext(type, title, tags));
  }

  function truthyAttr(value) {
    return value === true || value === 'true' || value === '1';
  }

  function falsyAttr(value) {
    return value === false || value === 'false' || value === '0';
  }

  function readCard(el) {
    return {
      el: el,
      handle: el.dataset.djPgHandle || el.dataset.productHandle || '',
      url: el.dataset.djPgUrl || '',
      styleGroup: el.dataset.djPgStyleGroup || '',
      groups: splitPipe(el.dataset.djPgGroups),
      groupGids: splitPipe(el.dataset.djPgGids),
      primaryGroup: el.dataset.djPgPrimaryGroup || '',
      primaryGid: el.dataset.djPgPrimaryGid || '',
      titleFirst: el.dataset.djPgTitleFirst || '',
      titleRest: el.dataset.djPgTitleRest || '',
      color: el.dataset.djPgColor || '',
      colorPatternId: el.dataset.djPgCpId || '',
      colorPatternLabel: el.dataset.djPgCpLabel || '',
      swatchColor: el.dataset.djPgSwatchColor || '#8A9AAB',
      swatchImage: el.dataset.djPgSwatchImage || '',
      image: el.dataset.djPgImage || '',
      imageSecondary: el.dataset.djPgImageSecondary || '',
      priceHtml: el.dataset.djPgPriceHtml || '',
      compareHtml: el.dataset.djPgCompareHtml || '',
      onSale: el.dataset.djPgOnSale === 'true',
      available: el.dataset.djPgAvailable !== 'false',
      showInPicker: !falsyAttr(el.dataset.djPgShowInPicker),
      pinColor: truthyAttr(el.dataset.djPgPinColor),
      isOverall: el.dataset.djPgIsOverall === 'true',
      isBottoms: el.dataset.djPgIsBottoms === 'true',
      isTops: el.dataset.djPgIsTops === 'true'
    };
  }

  function markTencel(text) {
    return String(text || '').replace(
      /(^|[^A-Za-z0-9-])tencel(?=$|[^A-Za-z0-9-])(?:\s*(?:™|&trade;|&#8482;))*/gi,
      function (_match, prefix) {
        return prefix + 'TENCEL™';
      }
    );
  }

  function displayColor(data) {
    var color = data.color || data.colorPatternLabel || '';
    if (!color) return '\u00a0';
    return markTencel(color);
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  var DJ_TYPE_WORDS =
    'JEAN,JEANS,PANT,PANTS,TROUSER,TROUSERS,SHORT,SHORTS,SKIRT,SKIRTS,DRESS,DRESSES,TOP,TOPS,TEE,TEES,TANK,TANKS,BLOUSE,BLOUSES,SHIRT,SHIRTS,SWEATER,SWEATERS,CARDIGAN,CARDIGANS,JACKET,JACKETS,BLAZER,BLAZERS,COAT,COATS,VEST,VESTS,OVERALL,OVERALLS,JUMPSUIT,JUMPSUITS,ROMPER,ROMPERS,LEGGING,LEGGINGS,JOGGER,JOGGERS'.split(
      ','
    );

  function styleName(title) {
    var raw = String(title || '')
      .trim()
      .replace(/\s+/g, ' ');
    if (!raw) return '';
    var words = raw.split(' ');
    var last = -1;
    for (var i = 0; i < words.length; i++) {
      if (DJ_TYPE_WORDS.indexOf(words[i].toUpperCase()) !== -1) last = i;
    }
    if (last >= 0) return words.slice(0, last + 1).join(' ');
    return raw;
  }

  function parseTitleParts(title, colorHint) {
    var raw = String(title || '').trim();
    var cardTitle = styleName(raw);
    if (cardTitle === raw && colorHint) {
      var re = new RegExp(
        '\\s*' + String(colorHint).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$',
        'i'
      );
      cardTitle = cardTitle.replace(re, '').trim();
    }
    cardTitle = markTencel(cardTitle);
    var words = cardTitle.split(/\s+/).filter(Boolean);
    return {
      titleFirst: words[0] || '',
      titleRest: words.slice(1).join(' ')
    };
  }

  function cardToStorage(card) {
    return {
      handle: card.handle,
      url: card.url,
      title: [card.titleFirst, card.titleRest].filter(Boolean).join(' '),
      color: displayColor(card),
      colorPatternId: card.colorPatternId,
      swatchColor: card.swatchColor,
      swatchImage: card.swatchImage || '',
      image: card.image,
      available: card.available,
      showInPicker: card.showInPicker !== false,
      pinColor: !!card.pinColor,
      groups: card.groups,
      groupGids: card.groupGids,
      styleGroup: card.styleGroup || ''
    };
  }

  function persistGroups(groupsMap) {
    try {
      var out = {};
      Object.keys(groupsMap).forEach(function (groupName) {
        var bucket = groupsMap[groupName];
        if (bucket.length > 1) {
          out[groupName] = bucket.map(cardToStorage);
        }
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(out));
    } catch (err) {
      /* ignore */
    }
  }

  /**
   * product_groups metaobject names often append year/season
   * ("FIONA WIDE LEG JEAN 2026", "HAMPTON SHORT CURRENT"). Strip those so
   * colorways still share one style group on PLP/PDP.
   */
  function normalizeGroupKey(name) {
    var s = String(name || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!s) return '';
    s = s.replace(
      /\s+(?:20\d{2}|CURRENT|CORE|FAL\+HOL|SPR\+SUM|FALL'? ?\d{2}|SPRING'? ?\d{2}|HOLIDAY)\s*$/i,
      ''
    );
    return s.replace(/\s+/g, ' ').trim();
  }

  function groupKeyForCard(card) {
    var raw = card.styleGroup || card.primaryGroup || (card.groups && card.groups[0]) || '';
    return normalizeGroupKey(raw);
  }

  function buildGroupsMap(cards) {
    var map = {};
    cards.forEach(function (card) {
      var key = groupKeyForCard(card);
      if (!key) return;
      if (!map[key]) map[key] = [];
      if (!map[key].some(function (c) {
        return c.handle === card.handle;
      })) {
        map[key].push(card);
      }
    });
    return map;
  }

  function sortBucket(bucket) {
    return bucket.slice().sort(function (a, b) {
      var ap = a.pinColor ? 0 : 1;
      var bp = b.pinColor ? 0 : 1;
      if (ap !== bp) return ap - bp;
      return String(displayColor(a) || a.handle)
        .toLowerCase()
        .localeCompare(String(displayColor(b) || b.handle).toLowerCase());
    });
  }

  function filterPickerBucket(bucket, currentHandle) {
    return bucket.filter(function (c) {
      if (c.handle === currentHandle) return true;
      if (c.showInPicker === false) return false;
      if (!showSoldOut() && c.available === false) return false;
      return true;
    });
  }

  function findLink(cardEl) {
    return cardEl.querySelector('.grid-product__link');
  }

  function setImgSrc(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
  }

  function applyCard(cardEl, data) {
    var link = findLink(cardEl);
    if (link) link.setAttribute('href', data.url || '/products/' + data.handle);

    var sourceTitle = data.title || [data.titleFirst, data.titleRest].filter(Boolean).join(' ');
    var parts = parseTitleParts(sourceTitle, data.color || data.colorPatternLabel);
    var styleLabel = [parts.titleFirst, parts.titleRest].filter(Boolean).join(' ');

    var titleFirst = cardEl.querySelector('.dj-title-first');
    var titleRest = cardEl.querySelector('.dj-title-rest');
    if (titleFirst) titleFirst.textContent = parts.titleFirst || '';
    if (titleRest) titleRest.textContent = parts.titleRest || '';

    var colorLine =
      cardEl.querySelector('[data-dj-pg-color-line]') || cardEl.querySelector('.grid-product__color-name');
    if (colorLine) colorLine.textContent = displayColor(data);

    var priceWrap = cardEl.querySelector('.grid-product__price');
    if (priceWrap) {
      if (data.onSale && data.compareHtml) {
        priceWrap.innerHTML =
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="grid-product__price--original">' +
          data.compareHtml +
          '</span>' +
          '<span class="visually-hidden">Sale price</span>' +
          '<span class="sale-price">' +
          data.priceHtml +
          '</span>';
      } else {
        priceWrap.innerHTML = '<span>' + (data.priceHtml || '') + '</span>';
      }
    }

    cardEl.querySelectorAll('.grid-product__image-mask img, .grid-product__link img').forEach(function (img) {
      setImgSrc(img, data.image);
      if (styleLabel) img.alt = styleLabel;
    });

    var secondaryWrap = cardEl.querySelector('.grid-product__secondary-image');
    var secondary = cardEl.querySelector('.grid-product__secondary-image img');
    if (secondaryWrap && secondary) {
      if (data.imageSecondary) {
        setImgSrc(secondary, data.imageSecondary);
        secondaryWrap.style.display = '';
      } else if (data.image) {
        setImgSrc(secondary, data.image);
      }
    }

    cardEl.dataset.djPgActiveHandle = data.handle;
    cardEl._djPgActive = data;
  }

  function swatchBackground(sibling) {
    if (sibling.swatchImage) return sibling.swatchImage;
    if (sibling.image) return sibling.image;
    return '';
  }

  function siblingUrl(sibling) {
    return sibling.url || (sibling.handle ? '/products/' + sibling.handle : '');
  }

  function renderSwatches(cardEl, bucket, active) {
    var container = cardEl.querySelector('[data-dj-pg-swatches]');
    if (!container) return;

    container.innerHTML = '';
    var seen = {};
    var sorted = sortBucket(filterPickerBucket(bucket, active.handle));

    // Each colorway stays a first-class product URL (SEO: each can be "the main").
    // Shoppers still see one grouped card; crawlers/new-tab get real product links.
    sorted.forEach(function (sibling) {
      var key = sibling.colorPatternId || sibling.handle;
      if (seen[key]) return;
      seen[key] = true;

      var isActive = sibling.handle === active.handle;
      var link = document.createElement('a');
      link.className = 'color-swatch color-swatch--small' + (isActive ? ' is-active' : '');
      link.href = siblingUrl(sibling);
      link.dataset.djPgHandle = sibling.handle;
      link.setAttribute('aria-label', displayColor(sibling) || sibling.handle);
      link.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) link.setAttribute('aria-current', 'true');
      link.style.backgroundColor = sibling.swatchColor || '#8A9AAB';
      var bg = swatchBackground(sibling);
      if (bg) {
        link.style.backgroundImage = 'url(' + bg + ')';
        link.classList.add('color-swatch--with-image');
      }
      if (sibling.isOverall) link.classList.add('color-swatch--overall');
      if (sibling.isBottoms) link.classList.add('color-swatch--bottoms');
      if (sibling.isTops) link.classList.add('color-swatch--tops');
      if (sibling.available === false) link.classList.add('is-sold-out');
      // Visible color name for a11y; CSS clips to swatch face.
      link.textContent = link.getAttribute('aria-label');

      container.appendChild(link);
    });
  }

  function pickSwatch(cardEl, picked) {
    var bucket = cardEl._djPgBucket;
    if (!bucket || !picked) return;

    window.__djPgUpdating = true;
    try {
      applyCard(cardEl, picked);
      renderSwatches(cardEl, bucket, picked);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function bindGridDelegation(root) {
    if (!root || root.dataset.djPgDelegated) return;
    root.dataset.djPgDelegated = 'true';

    // SEO theme: each colorway is its own main card. Swatches are real product
    // links — follow them instead of soft-swapping the card face.
    root.addEventListener(
      'click',
      function (e) {
        var swatch = e.target.closest(
          '[data-dj-pg-swatches] a.color-swatch, [data-dj-pg-swatches] button.color-swatch'
        );
        if (!swatch) return;
        // Keep the click off the parent product card / quick-view.
        e.stopPropagation();
      },
      true
    );
  }

  function mountGroupedCard(cardEl, bucket, initialActive) {
    cardEl._djPgBucket = bucket;

    var activeHandle =
      cardEl.dataset.djPgActiveHandle ||
      (cardEl._djPgActive && cardEl._djPgActive.handle) ||
      initialActive.handle;

    var active =
      bucket.find(function (c) {
        return c.handle === activeHandle;
      }) || initialActive;

    window.__djPgUpdating = true;
    try {
      applyCard(cardEl, active);
      renderSwatches(cardEl, bucket, active);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function normalizeGid(id) {
    return String(id || '')
      .toLowerCase()
      .trim();
  }

  function storefrontGraphql(domain, token, query, variables) {
    if (!domain || !token) return Promise.resolve(null);
    return fetch('https://' + domain + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (payload) {
        return (payload && payload.data) || null;
      })
      .catch(function () {
        return null;
      });
  }

  var PRODUCT_FIELDS =
    'handle title availableForSale featuredImage{url} ' +
    'styleGroup:metafield(namespace:"custom",key:"style_group"){value} ' +
    'colorName:metafield(namespace:"custom",key:"color_name"){value} ' +
    'swatchImage:metafield(namespace:"custom",key:"swatch_image"){reference{... on MediaImage{image{url}}}} ' +
    'showInPicker:metafield(namespace:"custom",key:"show_in_color_picker"){value} ' +
    'pinColor:metafield(namespace:"custom",key:"pin_color"){value} ' +
    'pg:metafield(namespace:"custom",key:"product_groups"){references(first:3){nodes{... on Metaobject{id field(key:"name"){value}}}}} ' +
    'cp:metafield(namespace:"shopify",key:"color-pattern"){references(first:1){nodes{... on Metaobject{id color:field(key:"color"){value} label:field(key:"label"){value}}}}}';

  function fetchAllProductsByQuery(domain, token, searchQuery) {
    var all = [];
    var cursor = null;

    function page() {
      var gql =
        'query($q:String!,$cursor:String){products(first:' +
        PAGE_SIZE +
        ',after:$cursor,query:$q){pageInfo{hasNextPage endCursor} nodes{' +
        PRODUCT_FIELDS +
        '}}}';
      return storefrontGraphql(domain, token, gql, { q: searchQuery, cursor: cursor }).then(function (data) {
        var conn = (data && data.products) || {};
        var nodes = conn.nodes || [];
        all = all.concat(nodes);
        if (conn.pageInfo && conn.pageInfo.hasNextPage && conn.pageInfo.endCursor) {
          cursor = conn.pageInfo.endCursor;
          return page();
        }
        return all;
      });
    }

    return page();
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('product js failed');
      return r.json();
    });
  }

  function productJsToCard(data, groups, groupGids, extras) {
    extras = extras || {};
    var colorOpt = (data.options || []).find(function (o) {
      return /color|colour/i.test(o.name);
    });
    var color =
      extras.colorName ||
      extras.cpLabel ||
      (colorOpt && colorOpt.values && colorOpt.values[0]) ||
      '';
    var parts = parseTitleParts(data.title, color);
    var onSale = Number(data.compare_at_price) > Number(data.price);
    var priceHtml = formatMoney(data.price);
    if (data.price_varies) {
      priceHtml = 'From ' + formatMoney(data.price_min || data.price);
    }

    return {
      handle: data.handle,
      url: '/products/' + data.handle,
      styleGroup: extras.styleGroup || '',
      groups: groups || [],
      groupGids: groupGids || [],
      titleFirst: parts.titleFirst,
      titleRest: parts.titleRest,
      color: color,
      colorPatternId: extras.cpId || '',
      colorPatternLabel: extras.cpLabel || '',
      swatchColor: extras.cpColor || '#8A9AAB',
      swatchImage: extras.swatchImage || '',
      image: data.featured_image || '',
      imageSecondary: data.images && data.images[1] ? data.images[1] : '',
      priceHtml: priceHtml,
      compareHtml: onSale ? formatMoney(data.compare_at_price) : '',
      onSale: onSale,
      available: data.available !== false,
      showInPicker: extras.showInPicker !== false,
      pinColor: !!extras.pinColor,
      isOverall: isOverallProduct(data.type, data.title, data.tags),
      isBottoms: isBottomsProduct(data.type, data.title, data.tags),
      isTops: isTopsProduct(data.type, data.title, data.tags)
    };
  }

  function nodeExtras(node) {
    var cp = (((node.cp || {}).references || {}).nodes || [])[0] || {};
    var swatchRef = ((node.swatchImage || {}).reference || {}).image || {};
    return {
      styleGroup: (node.styleGroup && node.styleGroup.value) || '',
      colorName: (node.colorName && node.colorName.value) || '',
      swatchImage: swatchRef.url || '',
      showInPicker: !falsyAttr(node.showInPicker && node.showInPicker.value),
      pinColor: truthyAttr(node.pinColor && node.pinColor.value),
      cpId: cp.id || '',
      cpColor: (cp.color && cp.color.value) || '',
      cpLabel: (cp.label && cp.label.value) || '',
      available: node.availableForSale !== false,
      featuredImage: node.featuredImage ? node.featuredImage.url : ''
    };
  }

  function matchesStyleGroup(node, styleGroup) {
    var value = ((node.styleGroup && node.styleGroup.value) || '').trim();
    return value && value.toLowerCase() === String(styleGroup || '').toLowerCase();
  }

  function matchesProductGroupGid(node, groupGid) {
    var pgRefs = (((node.pg || {}).references || {}).nodes || []);
    return pgRefs.some(function (ref) {
      return normalizeGid(ref.id) === normalizeGid(groupGid);
    });
  }

  function matchesStyleTitle(node, groupName) {
    return (
      normalizeGroupKey(styleName(node.title || '')).toUpperCase() ===
      normalizeGroupKey(groupName).toUpperCase()
    );
  }

  function mergeCards(bucket, extras) {
    var out = bucket.slice();
    (extras || []).filter(Boolean).forEach(function (item) {
      if (!item.handle) return;
      if (!out.some(function (c) {
        return c.handle === item.handle;
      })) {
        out.push(item);
      }
    });
    return out;
  }

  function collectDomSiblings(groupName, seedCard) {
    if (!groupName) return [];
    var key = String(groupName).toUpperCase().trim();
    var styleGroup = (seedCard && seedCard.styleGroup) || '';
    return Array.prototype.map
      .call(document.querySelectorAll('[data-dj-pg-card]'), readCard)
      .filter(function (card) {
        if (!card.handle) return false;
        if (styleGroup && card.styleGroup) {
          return String(card.styleGroup).toLowerCase() === String(styleGroup).toLowerCase();
        }
        var cardKey = String(groupKeyForCard(card) || '').toUpperCase().trim();
        return cardKey === key;
      });
  }

  function fetchSuggestHandles(groupName) {
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(groupName) +
      '&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=last';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (payload) {
        var products =
          (payload &&
            payload.resources &&
            payload.resources.results &&
            payload.resources.results.products) ||
          [];
        return products
          .map(function (p) {
            return p && p.handle;
          })
          .filter(Boolean);
      })
      .catch(function () {
        return [];
      });
  }

  function cardsFromHandles(handles, seedCard, groupName) {
    var known = {};
    var styleGroup = (seedCard && seedCard.styleGroup) || '';
    return Promise.all(
      (handles || []).map(function (handle) {
        if (!handle || known[handle]) return Promise.resolve(null);
        known[handle] = true;
        return fetchProductJs(handle)
          .then(function (p) {
            if (styleGroup) {
              /* title fallback only when no style_group seed */
            } else if (!matchesStyleTitle({ title: p.title }, groupName)) {
              return null;
            }
            return productJsToCard(p, seedCard.groups, seedCard.groupGids, {});
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (cards) {
      return cards.filter(Boolean);
    });
  }

  function enrichBucket(groupName, groupGid, bucket, seedCard) {
    if (!groupName) return Promise.resolve(bucket || []);

    var seed = seedCard || (bucket && bucket[0]) || {};
    var styleGroup = seed.styleGroup || '';
    var out = mergeCards(bucket || [], collectDomSiblings(groupName, seed));

    var cfg = config();
    var domain = cfg.storefrontDomain;
    var token = cfg.storefrontToken;

    var storefrontPromise = Promise.resolve([]);
    if (domain && token) {
      var query = styleGroup
        ? 'metafields.custom.style_group:' + JSON.stringify(styleGroup)
        : groupName;
      storefrontPromise = fetchAllProductsByQuery(domain, token, query)
        .then(function (nodes) {
          var matched = (nodes || []).filter(function (n) {
            if (styleGroup) return matchesStyleGroup(n, styleGroup);
            if (groupGid) return matchesProductGroupGid(n, groupGid);
            return matchesStyleTitle(n, groupName);
          });
          var known = {};
          out.forEach(function (c) {
            known[c.handle] = true;
          });
          return Promise.all(
            matched
              .filter(function (n) {
                return n.handle && !known[n.handle];
              })
              .map(function (n) {
                var extras = nodeExtras(n);
                return fetchProductJs(n.handle)
                  .then(function (p) {
                    var card = productJsToCard(p, seed.groups, seed.groupGids, extras);
                    if (!card.image && extras.featuredImage) card.image = extras.featuredImage;
                    return card;
                  })
                  .catch(function () {
                    return null;
                  });
              })
          ).then(function (extra) {
            return extra.filter(Boolean);
          });
        })
        .catch(function () {
          return [];
        });
    }

    return storefrontPromise.then(function (fromStorefront) {
      out = mergeCards(out, fromStorefront);
      if (out.length > 1) return out;

      return fetchSuggestHandles(groupName).then(function (handles) {
        var known = {};
        out.forEach(function (c) {
          known[c.handle] = true;
        });
        var missing = handles.filter(function (h) {
          return !known[h];
        });
        return cardsFromHandles(missing, seed, groupName).then(function (fromSuggest) {
          return mergeCards(out, fromSuggest);
        });
      });
    });
  }

  function mutationIsGridReload(mutations) {
    return mutations.some(function (m) {
      var nodes = []
        .concat(Array.from(m.addedNodes || []), Array.from(m.removedNodes || []))
        .filter(function (n) {
          return n.nodeType === 1;
        });

      return nodes.some(function (node) {
        if (node.matches && node.matches('[data-dj-pg-card]')) return true;
        if (node.querySelector && node.querySelector('[data-dj-pg-card]')) return true;
        return false;
      });
    });
  }

  function initGrid(root) {
    if (!root) return;

    window.__djPgUpdating = true;

    try {
      var cardEls = root.querySelectorAll('[data-dj-pg-card]');
      if (!cardEls.length) return;

      bindGridDelegation(root);

      var cards = Array.prototype.map.call(cardEls, readCard);
      var groupsMap = buildGroupsMap(cards);

      // Never collapse siblings on the SEO theme: every colorway stays visible
      // as its own main card, each showing the full group swatch set.
      root.querySelectorAll('.dj-pg-collapsed').forEach(function (el) {
        el.classList.remove('dj-pg-collapsed');
        el.hidden = false;
      });

      var enrichments = Object.keys(groupsMap).map(function (groupName) {
        var onPage = groupsMap[groupName] || [];
        if (!onPage.length) return Promise.resolve();

        onPage.forEach(function (card) {
          mountGroupedCard(card.el, onPage, card);
          card.el.dataset.djPgGroup = groupName;
          card.el.classList.remove('dj-pg-collapsed');
          card.el.hidden = false;
        });

        var seed = onPage[0];
        return enrichBucket(groupName, seed.primaryGid, onPage.slice(), seed).then(function (
          fullBucket
        ) {
          if (!fullBucket || !fullBucket.length) return;
          groupsMap[groupName] = fullBucket;
          onPage.forEach(function (card) {
            var active =
              fullBucket.find(function (c) {
                return c.handle === card.handle;
              }) || card;
            mountGroupedCard(card.el, fullBucket, active);
            card.el.hidden = false;
            card.el.classList.remove('dj-pg-collapsed');
          });
        });
      });

      Promise.all(enrichments).then(function () {
        persistGroups(groupsMap);
      });

      persistGroups(groupsMap);
    } finally {
      window.__djPgUpdating = false;
    }
  }

  function initAllGrids() {
    var roots = [];
    document.querySelectorAll('[data-dj-pg-card]').forEach(function (card) {
      var root =
        card.closest('[data-dj-pg-grid], .product-grid-container') || card.parentElement;
      if (!root || roots.indexOf(root) !== -1) return;
      roots.push(root);
    });
    if (!roots.length) {
      var fallback = document.querySelector('.product-grid-container, [data-dj-pg-grid]');
      if (fallback) roots.push(fallback);
    }
    roots.forEach(function (root) {
      initGrid(root);
    });
  }

  function observeCollectionAjax() {
    var host = document.getElementById('CollectionAjaxContent') || document.getElementById('MainContent');
    if (!host || host.dataset.djPgObserved) return;
    host.dataset.djPgObserved = 'true';

    var timer;
    var obs = new MutationObserver(function (mutations) {
      if (window.__djPgUpdating) return;
      if (!mutationIsGridReload(mutations)) return;

      clearTimeout(timer);
      timer = setTimeout(function () {
        initAllGrids();
      }, 120);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  function getStoredSiblings(groupName) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed[groupName] || null;
    } catch (err) {
      return null;
    }
  }

  function ensurePdpHost() {
    var root = document.querySelector('[data-dj-pg-pdp-root]');
    var host = document.querySelector('[data-dj-pg-pdp-swatches]');
    if (host) {
      if (root) root.hidden = false;
      return host;
    }

    root = document.createElement('div');
    root.className = 'dj-pg-pdp-color-picker';
    root.setAttribute('data-dj-pg-pdp-root', 'true');
    root.innerHTML =
      '<p class="dj-pg-pdp-color-label">Color — <span data-dj-pg-pdp-color-label></span></p>' +
      '<div class="dj-pg-pdp-swatches" data-dj-pg-pdp-swatches></div>';

    var anchor =
      document.querySelector('.dj-variant-picker') ||
      document.querySelector('[data-product-blocks]') ||
      document.querySelector('.product-single__meta');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(root, anchor);
    }
    return root.querySelector('[data-dj-pg-pdp-swatches]');
  }

  function setNativeColorSlotHidden(hidden) {
    document.querySelectorAll('.dj-option-slot--color').forEach(function (slot) {
      if (hidden) {
        slot.classList.add('dj-pg-native-color-hidden');
        slot.setAttribute('aria-hidden', 'true');
      } else {
        slot.classList.remove('dj-pg-native-color-hidden');
        slot.removeAttribute('aria-hidden');
      }
    });
  }

  function mountPdpSwatches(context, siblings) {
    var host = ensurePdpHost();
    if (!host) return;

    var root = document.querySelector('[data-dj-pg-pdp-root]');
    var visible = filterPickerBucket(siblings, context.handle);
    if (visible.length < 2) {
      if (root) root.hidden = true;
      setNativeColorSlotHidden(false);
      return;
    }
    if (root) root.hidden = false;
    setNativeColorSlotHidden(true);

    var label = document.querySelector('[data-dj-pg-pdp-color-label]');
    if (label) label.textContent = displayColor(context);

    host.innerHTML = '';
    sortBucket(visible).forEach(function (sibling) {
      var isCurrent = sibling.handle === context.handle;
      var el = document.createElement('a');
      el.className = 'color-swatch' + (isCurrent ? ' is-active' : '');
      el.href = sibling.url || '/products/' + sibling.handle;
      el.setAttribute('aria-label', markTencel(sibling.color || sibling.title || sibling.handle || ''));
      el.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      if (isCurrent) el.setAttribute('aria-current', 'true');
      el.style.backgroundColor = sibling.swatchColor || '#8A9AAB';
      var bg = swatchBackground(sibling);
      if (bg) {
        el.style.backgroundImage = 'url(' + bg + ')';
        el.classList.add('color-swatch--with-image');
      }
      if (sibling.isOverall) el.classList.add('color-swatch--overall');
      if (sibling.isBottoms) el.classList.add('color-swatch--bottoms');
      if (sibling.isTops) el.classList.add('color-swatch--tops');
      if (sibling.available === false) el.classList.add('is-sold-out');
      el.textContent = el.getAttribute('aria-label');
      host.appendChild(el);
    });
  }

  function initPdp() {
    var node = document.getElementById('dj-pg-pdp-context');
    if (!node || node.dataset.djPgPdpInit === '1') return;
    node.dataset.djPgPdpInit = '1';

    var context;
    try {
      context = JSON.parse(node.textContent || '{}');
    } catch (err) {
      return;
    }

    var groupName = context.styleGroup || (context.groups && context.groups[0]) || '';
    if (!groupName) {
      var heading =
        document.querySelector('.product-single__title, .product__title, h1[itemprop="name"], .template-product h1');
      var headingText = heading ? String(heading.textContent || '').replace(/\s+/g, ' ').trim() : '';
      groupName = styleName(headingText);
      if (groupName) {
        context.groups = [groupName];
      }
    }
    if (!groupName) return;

    var groupGid = (context.groupGids && context.groupGids[0]) || '';
    var stored = getStoredSiblings(groupName);
    if (stored && stored.length > 1) {
      mountPdpSwatches(context, stored);
    }

    var seedCard = {
      styleGroup: context.styleGroup || '',
      groups: context.groups || [groupName],
      groupGids: context.groupGids || [],
      handle: context.handle,
      url: context.url || '/products/' + context.handle,
      color: context.color,
      swatchColor: context.swatchColor,
      swatchImage: context.swatchImage,
      showInPicker: context.showInPicker !== false,
      pinColor: !!context.pinColor,
      available: context.available !== false
    };

    var cfg = config();
    if (!cfg.storefrontDomain) cfg.storefrontDomain = context.storefrontDomain;
    if (!cfg.storefrontToken) cfg.storefrontToken = context.storefrontToken;
    window.djParentGroupConfig = cfg;

    var bestCount = stored && stored.length > 1 ? stored.length : 1;
    var enriching = false;

    function runEnrich() {
      if (enriching) return;
      enriching = true;
      enrichBucket(groupName, groupGid, [seedCard], seedCard)
        .then(function (siblings) {
          if (siblings.length < 2 || siblings.length < bestCount) return;
          bestCount = siblings.length;
          try {
            var raw = localStorage.getItem(STORAGE_KEY);
            var parsed = raw ? JSON.parse(raw) : {};
            parsed[groupName] = siblings.map(cardToStorage);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
          } catch (err) {
            /* ignore */
          }
          mountPdpSwatches(context, siblings);
        })
        .finally(function () {
          enriching = false;
        });
    }

    runEnrich();

    // Related / recommendation rails often inject sibling cards after boot.
    var retries = 0;
    var retryTimer = setInterval(function () {
      retries += 1;
      runEnrich();
      if (retries >= 6 || bestCount > 3) clearInterval(retryTimer);
    }, 800);

    var host = document.querySelector('.product-section, main, #MainContent') || document.body;
    if (host && !host.dataset.djPgPdpObserved) {
      host.dataset.djPgPdpObserved = 'true';
      var obs = new MutationObserver(function (mutations) {
        if (window.__djPgUpdating) return;
        var found = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes || [], function (n) {
            return (
              n.nodeType === 1 &&
              ((n.matches && n.matches('[data-dj-pg-card]')) ||
                (n.querySelector && n.querySelector('[data-dj-pg-card]')))
            );
          });
        });
        if (found) runEnrich();
      });
      obs.observe(host, { childList: true, subtree: true });
    }
  }

  function boot() {
    initAllGrids();
    observeCollectionAjax();
    initPdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
